export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-background-50"></div>
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(232,131,42,0.5) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(232,84,58,0.4) 0%, transparent 50%), radial-gradient(circle at 50% 80%, rgba(201,151,58,0.3) 0%, transparent 50%)',
      }}></div>

      <div className="relative z-10 w-full mx-auto max-w-[1440px] px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse-soft"></span>
              <span className="text-xs md:text-sm font-medium text-primary-400">2026暑期档 · 每日更新中</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading leading-tight mb-5">
              四虎影视大全
              <span className="block text-primary-400 mt-2">海量电视剧免费全集在线观看</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-5">
              四虎影视大全汇聚全网最全电视剧资源，古装、悬疑、都市、仙侠、谍战全品类覆盖。
              每日同步更新最新上线剧集，无需逐集寻找，一次性畅享完整剧情。
              2026暑期档多部年度大剧全集已上线，4K高清画质免费观看。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">8000+</div>
                <div className="text-xs text-foreground-500 mt-1">收录剧集</div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">50+部新内容</div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-400 font-heading">5000万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃剧迷</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all duration-200 whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-300/60 hover:border-primary-400/50 text-foreground-700 hover:text-primary-400 font-medium text-sm transition-all duration-200 whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-1 rounded-2xl bg-gradient-to-br from-primary-500/30 via-accent-500/20 to-secondary-500/30 blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20cinematic%20poster%20collection%2C%20ancient%20palace%20silhouette%20with%20warm%20golden%20hour%20lighting%2C%20traditional%20Chinese%20architecture%2C%20dramatic%20clouds%2C%20movie%20poster%20quality%20with%20rich%20amber%20and%20crimson%20tones%2C%20epic%20scale%2C%20professional%20cinematography&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                  alt="四虎影视大全电视剧全集在线观看 - 热门剧集精选"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-semibold whitespace-nowrap">今日更新</span>
                  <span className="text-xs text-foreground-300">长安十二时辰2 · 狐妖小红娘 · 大江大河4</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent pointer-events-none"></div>
    </section>
  );
}